import { normalizeCarrierCode } from './definitions';

export const carriersFilter = (
  searchResults,
  carrierSelected,
  isCustomSearch
) => {
  if (carrierSelected.includes('allOptions')) return [...searchResults];

  const selectedCodes = new Set(
    carrierSelected.map(c => normalizeCarrierCode(c.code))
  );

  return searchResults.filter(item => {
    const code = isCustomSearch
      ? item.combinations[0].cluster.carrier.code
      : item.cluster.carrier.code;

    return selectedCodes.has(normalizeCarrierCode(code));
  });
};
